<script>
// @ts-nocheck

import { PortableText } from '@portabletext/svelte';
export let section = false;

let { headline, body } = section;
let searchQuery = '';

function handleSubmit(event) {
  event.preventDefault();
  // Navigate to the search results page with the searchQuery
  window.location.href = `/support/search?query=${encodeURIComponent(
    searchQuery
  )}`;
}
</script>

<section class="support-search-section" class:is-compressed={section === false}>
  <div class="container-fluid">
    <div class="row center-md">
      <div class="col-sm-12 col-md-12 col-lg-11">
        {#if section !== false}
          <h1 class="support-search__headline">{headline}</h1>
          <div class="support-search__body">
            <PortableText value={body} />
          </div>
        {/if}

        <div class="support-search__form-container">
          <form class="support-search__form" on:submit={handleSubmit}>
            <div class="support-search__input-wrapper">
              <div class="support-search__input-icon">
                <svg>
                  <title>Search Icon</title>
                  <use xlink:href="#icon-search" />
                </svg>
              </div>
              <label for="search-query" class="visually-hidden">
                Search Query
              </label>
              <input
                id="search-query"
                name="Search Query"
                type="text"
                required
                bind:value={searchQuery}
                class="inpu input--primary  input--large"
                placeholder="Type your search query"
              />
              <button
                class="button--primary  button--medium"
                type="submit"
                aria-label="Search documentation"
              >
                <span> Submit Query </span>
              </button>
            </div>
          </form>
        </div>
        {#if section !== false}
          <div class="support-search__down-arrow">
            <svg>
              <title>Search Icon</title>
              <use xlink:href="#icon-directional-down-arrow" />
            </svg>
          </div>
        {/if}
      </div>
    </div>
  </div>
</section>

<style>
.support-search-section {
  margin-top: -6rem;
  width: 100%;
  padding-top: 7rem;
  background-color: var(--tertiary-color);
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--quaternary-color);
  margin-bottom: 3.5rem;
}

.support-search-section.is-compressed {
  padding-bottom: 0.5rem;
  padding-top: 6rem;
  margin-bottom: 3rem;
}

@media only screen and (min-width: 768px) {
  .support-search-section {
    padding-top: 6rem;
  }
}

@media only screen and (min-width: 961px) {
  .support-search-section {
    padding-top: 6rem;
    margin-bottom: 4.5rem;
  }

  .support-search-section.is-compressed {
    padding-bottom: 0.5rem;
    padding-top: 5rem;
  }
}

.support-search__headline {
  text-align: center;
  font-family: var(--secondary-font-family);
  color: var(--primary-color);
  font-size: var(--h3);
  margin-bottom: 0.5rem;
}

.support-search__body {
  text-align: center;
  font-size: var(--h5);
  max-width: 32rem;
  margin-right: auto;
  margin-left: auto;
}

:global(.support-search__body p) {
  margin-bottom: 1.5rem;
}

@media only screen and (min-width: 961px) {
  .support-search__body {
    max-width: 65ch;
    margin-bottom: 0.5rem;
  }
}

.support-search__form-container {
  margin-bottom: 1.5rem;
}

.support-search__form button {
  opacity: 0;
  position: fixed;
}

.support-search__input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.support-search__form input {
  border-radius: 60px;
  padding-left: 3.5rem;
  margin-bottom: 0;
}

.support-search__input-icon {
  width: 1.75rem;
  height: 1.75rem;
  position: absolute;
  left: 1rem;
}
.support-search__input-icon svg {
  width: 100%;
  height: 100%;
}

.support-search__down-arrow {
  width: 2.5rem;
  height: 2.5rem;
  margin-left: auto;
  margin-right: auto;
}

@media only screen and (min-width: 961px) {
  .support-search__down-arrow {
    width: 2rem;
    height: 2rem;
    margin-left: auto;
  }
}

.support-search__down-arrow svg {
  width: 100%;
  height: 100%;
}
</style>
